import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://uryvnmlaovdnnksifwga.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVyeXZubWxhb3Zkbm5rc2lmd2dhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM1NTYwNjQsImV4cCI6MjA2OTEzMjA2NH0.7lUEL5rjkyg4EKwp8bX8e8WgKbySML0auvLXjZcpEuk';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: {
    schema: 'public',
  },
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false
  },
  global: {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  },
});

// Tipos para o banco de dados
export interface Usuario {
  id: string;
  email: string;
  nome_completo: string;
  empresa: string;
  cnpj?: string;
  cargo?: string;
  tipo_usuario: 'admin' | 'usuario' | 'gestor' | 'BASICO' | 'PROFISSIONAL' | 'ENTERPRISE' | 'SUPER_ADMIN';
  ativo: boolean;
  data_termino_mandato?: string;
  ultimo_acesso?: string;
  created_at: string;
  updated_at: string;
}

export interface AuthResponse {
  success: boolean;
  user?: Usuario;
  error?: string;
}
